import { PageRouteBuilder } from "@common/route/page-route-builder";
import { TriggerStewardshipActivityComponent } from "./trigger-stewardship-activity.component";

export const triggerStewardshipActivityRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-trigger-stewardship-activity", TriggerStewardshipActivityComponent)
    .requiresLogin()
    .atUrl("/tools/trigger-stewardship-activity")
    .withTitle("Trigger Stewardship Activity Checks")
    .build();
